import './index.css';
import '../contest_details/index_web.css';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteLocation, useLink } from 'react-router-stack';
import {
  Header,
  ScreenBackground,
  PlaceHolder,
  View,
  ErrorMessage,
  RouteWrapper,
  Text
} from '../../../component';
import useGame from '../../../utilities/hooks/game';
import { useEffect, useState } from 'react';
import {
  ContestCard,
  ContestDetailsTabBar,
  ContestDetailsWinningBreakup,
  ContestLeaderboard,
  ContestShare
} from '../../component';
import {
  formattedWinningsPerPosition,
  getTeamA,
  getTeamB,
  isGadgetLeague,
  isMatchInScheduled
} from '../../../utilities/helper';
import SwipeableViews from 'react-swipeable-views';
import { updateGameType } from '../../../actions/user-actions-types';
import I18n from '../../../utilities/locale';
import useTheme from '../../../utilities/hooks/theme';

const ContestShareLanding = () => {
  const { FantasyTheme: theme } = useTheme();
  const { state }: any = useRouteLocation();
  const { matchId = '', contestId = '', type: gameType = '' } = state;
  const [matchLoading, setMatchLoading] = useState(true);
  const [contestLoading, setContestLoading] = useState(true);
  const [matchLoadingError, setMatchLoadingError] = useState(false);
  const [contestLoadingError, setContestLoadingError] = useState(false);
  const navigate = useLink();
  const dispatch = useDispatch();

  const [matchTitle, setMatchTitle] = useState('Join Contest');
  const [matchDetail, setMatchDetails] = useState({} as any);
  const [matchStatus, setMatchStatus] = useState(1);
  const [matchDelayed, setMatchDelayed] = useState(false);
  const [matchGameState, setMatchGameState] = useState(0);

  const [tabType] = useState('FIXTURE');
  const [contestDetails, setContestDetails] = useState({} as any);
  const [isGadgetLeague_, setIsGadgetLeague_] = useState(false);
  const [contestDescription, setContestDescription] = useState('');
  const [winningData, setWinningData] = useState([]);

  const [activeTab, setActiveTab] = useState(0);
  const [contestShare, setContestShare] = useState(false);
  const [contestLink] = useState('');
  const [contestTitle] = useState('');

  const [routes] = useState([
    { key: 'Winnings', title: 'Winnings Breakup' },
    { key: 'LeaderBoard', title: 'LeaderBoard' }
  ]);

  const {
    myTeamList = [],
    shareContestStatus = {},
    userId = '',

    getContestDetailsById,
    getContestLeaderboard,
    fantasyMatchClick,
    getMyMatchTeamList,
    getMatchDetailsById,
    getPlayerList,
    getContestUserLeaderboard,
    setMyTeamList
  } = useGame(gameType);

  const { entryFee = 0, bonusPercentage, winningsPerPosition } = contestDetails;

  const { verified: matchVerifiedStatus = false, matchTeamLock = false } = matchDetail;

  const totalTeamsCount = myTeamList.length;

  // eslint-disable-next-line no-unused-vars
  const { isJoined = false } = shareContestStatus;

  useEffect(() => {
    dispatch(setMyTeamList([]));
    getContestDetails();
    getMatchDetailsByIdAPI();
    getMyTeamList();
  }, []);

  const getMyTeamList = () => {
    const data = {
      matchId,
      userId
    };
    dispatch(
      getMyMatchTeamList({
        data,
        callback: () => {}
      })
    );
  };

  const getContestDetails = () => {
    dispatch(
      getContestDetailsById({
        data: { contestId },
        callback: ({ result, error }: { result: any; error: any }) => {
          if (!error) {
            const { winningsPerPosition = {}, title = '', description = '' } = result;
            setContestLoadingError(false);
            setContestLoading(false);
            setContestDetails(result);
            setIsGadgetLeague_(isGadgetLeague(title));
            setWinningData(formattedWinningsPerPosition(winningsPerPosition));
            setContestDescription(description);
          } else {
            setContestLoadingError(true);
          }
        }
      })
    );
  };

  const getMatchDetailsByIdAPI = () => {
    dispatch(
      getMatchDetailsById({
        data: { id: matchId },
        callback: ({ result, error }: { result: any; error: any }) => {
          if (!error) {
            setMatchLoadingError(false);
            setMatchLoading(false);
            const { status = '', gameState = 0, matchDelayed = false } = result;
            const teamA = getTeamA(result, gameType) || {};
            const teamB = getTeamB(result, gameType) || {};
            setMatchDetails({ ...result, teamA, teamB });
            setMatchStatus(status);
            setMatchGameState(gameState);
            setMatchDelayed(matchDelayed);
            dispatch(updateGameType(gameType));
            setMatchTitle(`Join Contest (${teamA?.shortName} vs ${teamB?.shortName})`);
          } else {
            setMatchLoadingError(true);
          }
        }
      })
    );
  };

  const onPressCard = () => {};

  const onPressShare = async () => {};

  const onChangeTabIndex = (index = 0) => {
    setActiveTab(index);
  };

  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  const onPressShareModalDismiss = () => {
    setContestShare(false);
  };

  const isMatchInScheduled_ = isMatchInScheduled({
    matchStatus,
    gameState: matchGameState,
    matchDelayed,
    gameType
  });

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const footerTitle = {
    color: theme.contestDetailsFooterText
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header title={matchTitle} onClickBack={onPressBack} />
        {matchLoading || contestLoading ? (
          <PlaceHolder.Loader />
        ) : matchLoadingError || contestLoadingError ? (
          <ErrorMessage />
        ) : (
          <View className={'contest-share-landing-container'}>
            <ContestCard
              onPressCard={onPressCard}
              contest={contestDetails}
              onPressShare={onPressShare}
              matchStatus={matchStatus}
              gameState={matchGameState}
              matchItem={matchDetail}
              totalTeamsCount={totalTeamsCount}
              screenName={'CONTEST_SHARE_LANDING'}
              matchDelayed={matchDelayed}
              gameType={gameType}
            />
            <View className={'contest-details-tab-view-wrapper '}>
              <View
                style={{
                  flexGrow: 1,
                  height: '100%'
                }}>
                <ContestDetailsTabBar
                  onChangeTab={onChangeTab}
                  activeTab={activeTab}
                  routes={routes}
                />
                <div className="flat-list-outer-grow">
                  <SwipeableViews
                    index={activeTab}
                    onChangeIndex={onChangeTabIndex}
                    className={'contest-details-swipeable-view'}>
                    <ContestDetailsWinningBreakup
                      winningData={winningData}
                      isGadgetLeague={isGadgetLeague_}
                      description={contestDescription}
                    />
                    <ContestLeaderboard
                      getContestUserLeaderboard={getContestUserLeaderboard}
                      getContestLeaderboard={getContestLeaderboard}
                      fantasyMatchClick={fantasyMatchClick}
                      completed={!isMatchInScheduled_}
                      matchStatus={matchStatus}
                      matchItem={matchDetail}
                      contestId={contestId}
                      userId={userId}
                      winningsPerPosition={winningsPerPosition}
                      entryFee={entryFee}
                      tabType={tabType}
                      matchVerifiedStatus={matchVerifiedStatus}
                      bonusPercentage={bonusPercentage}
                      gameState={matchGameState}
                      matchId={matchId}
                      getPlayerList={getPlayerList}
                      matchTeamLock={matchTeamLock}
                      gameType={gameType}
                      myTeamListLen={myTeamList.length}
                      isGadgetLeague={isGadgetLeague_}
                    />
                  </SwipeableViews>
                </div>
              </View>
              <Text className={'contest-details-footer-title '} style={footerTitle}>
                {I18n.t('DeductionOver10000')}
              </Text>
            </View>
          </View>
        )}
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default ContestShareLanding;
